export default {"src":"/_next/static/media/tusd.0d1a7bec.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};